module.exports = __webpack_public_path__ + "static/media/MAAS-Routing_Direction.0985370d.png";